import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from '../scss/ui/share.scss'
import style from '../scss/layout/app.scss'
import fansidedLogo from '../images/fansided-logo.png'
import mobileLogo from '../images/GoTPicker-Logo__white.png'

const MobileIntro = ({ classDeactive }) => (
    <div className={cx(style.mobile, styles.share, classDeactive && 'deactivate', 'owl-small')}>
        <img src={mobileLogo} alt="Logo" />
        <h3>PRESENTED BY</h3>
        <img src={fansidedLogo} className={style.fansidedLogo} alt="FanSided Logo" />
        <h3>Tap to Begin!</h3>
    </div>
)

MobileIntro.propTypes = {
    classDeactive: PropTypes.bool.isRequired,
}

export default MobileIntro



// WEBPACK FOOTER //
// ./src/ui/MobileIntro.js